export default {
  rateLimits: [],
  status: {},
};